module.exports = __webpack_public_path__ + "img/mpw.f8d57e5f.png";